import React from "react";
import { useNavigate } from "react-router-dom";
import { AppTitle } from "@/shared/Components";
import { AppHighlighter } from "@/shared/Components/AppHighlighter";
import { handleFullName } from "@/shared/utils";
import type { SearchResponseItem } from "@/services/api/entities/search";
import { SearchCardField } from "../../CardField";
import styles from "./styles.module.scss";

type ContactSearchCardProps = {
  item: SearchResponseItem;
  setOpen: (value: boolean) => void;
  textQuery: string;
};

export const ContactSearchCard = (props: ContactSearchCardProps) => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate(`/contacts/generalInfo/${props.item?.personId}`);
    props.setOpen(false);
  };

  return (
    <div className={styles.container} onClick={handleContactClick}>
      <AppTitle titleType="primary" level={5}>
        <AppHighlighter
          searchWords={[props.textQuery]}
          textToHighlight={`${handleFullName(props.item.firstName, props.item.lastName)}`}
        />
      </AppTitle>
      <div className={styles.fields}>
        {props.item.fields.map((field, index) => {
          return (
            <SearchCardField
              type={"person"}
              textQuery={props.textQuery}
              field={field}
              key={index}
            />
          );
        })}
      </div>
    </div>
  );
};
